// extracted by mini-css-extract-plugin
export default {"form":"AddTodo_form__5uWhY","input":"AddTodo_input__Me9JC","button":"AddTodo_button__5flnM"};